<script>
    import { onMount } from 'svelte/internal';
    import { code, map, zone_selected , current_magnify_level, magnify_levels} from '../store';
    import Pin from './button_pin.svelte'

    let shift;
    let pinned_map;
    let last_magnify_level;
    let img;    

    export let moveX, moveY;
    const speed = 10;
    const tick = 100;
    const w = 3127;
    const h = 1630;

    const clamp = (val, min, max) => Math.min(Math.max(val, min), max);
    
    setInterval(() => {
        if(moveX == 0 && moveY == 0) return;

        let rescaled_coord = getTransformMatrix();

        let x = parseFloat(rescaled_coord[4]) - moveX * speed * -1;
        let y = parseFloat(rescaled_coord[5]) + moveY * speed * -1;


        let _x = 50 - ((x / w) * 100);
        let _y = 50 - ((y / h) * 100);

        let magnify_multiplier = $magnify_levels[$current_magnify_level];

        _x = clamp(_x, 0, 100 * magnify_multiplier);
        _y = clamp(_y, 0, 100 * magnify_multiplier);

        _x = 50 - _x;
        _y = 50 - _y;

        shift = `translate(${_x}%, ${_y}%)`;

        console.log(shift)
    }, tick);

    const getTransformMatrix = () => {
        let current_transform = window.getComputedStyle(pinned_map);
        let matrix = current_transform.transform || current_transform.webkitTransform || current_transform.mozTransform;
        
        if(matrix == 'none'){
            return matrix;
        }

        let matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ');

        return matrixValues;
    }

    const rescale_translate = (x, y, magnify_level = $current_magnify_level) => {
        let magnify_multiplier = $magnify_levels[magnify_level];
        let magnify_reducer = $magnify_levels[last_magnify_level];

        let _x, _y;

        _x = x / w;
        _x = 50 - (_x * 100);
        _x = _x / magnify_reducer;
        _x = _x * magnify_multiplier;
        _x = 50 - _x;

        _y = y / h;
        _y = 50 - (_y * 100);
        _y = _y / magnify_reducer;
        _y = _y * magnify_multiplier;
        _y = 50 - _y;
        
        return [_x , _y];
    }

    const code_rescale = (x, y) => {

        let magnify_multiplier = $magnify_levels[$current_magnify_level];
        let _x = 50 - x;
        _x = _x * magnify_multiplier;
        _x = 50 - _x;

        let _y = 50 - y;
        _y = _y * magnify_multiplier;
        _y = 50 - _y;

        return [_x , _y];
    }

    let focus_on_zone = '';
    onMount(()=>{
        current_magnify_level.subscribe((val) => {
            if(pinned_map == undefined) return;
            let magnify_multiplier = $magnify_levels[val];

            let matrixValues = getTransformMatrix();
            let x = parseFloat(matrixValues[4]);
            let y = parseFloat(matrixValues[5]);

            let rescaled_coord = rescale_translate(x, y, val);
            last_magnify_level = val;
            if(rescaled_coord == false) return;

            shift = `translate(${rescaled_coord[0]}%, ${rescaled_coord[1]}%)`;
        });

        code.subscribe((val)=>{
            if(val == '') return;
            focus_on_zone = val.slice(0,2);
            $zone_selected = focus_on_zone;

            let left = 0;
            let top = 0;
            let pin = document.getElementById(`pin-${val}`);
            if(pin == undefined) {
                // let pos = $map.find(x=>x.name == focus_on_zone).pins.find(x=>x.name = val.slice(2, val.length)).position;
                let section = $map.find(x=>x.name == focus_on_zone);
                shift = section.shift_3D;
                return;
            }else{
                left = parseFloat(pin.style.left.replace('%', ''));
                top = parseFloat(pin.style.top.replace('%', ''));
            }

            if(left > 50)
                left = -(Math.abs(left) - 50);
            else
                left = 50 - Math.abs(left);

            if(top > 0)
                top = 50 - top;

            let coord = code_rescale(left, top);
            shift = `translate(${coord[0]}%, ${coord[1]}%)`;
        });

    })

</script>

<div id='pinned-map' bind:this={pinned_map}  style="transform: {shift} scale({$magnify_levels[$current_magnify_level]})">
    <img bind:this={img} src='./assets/images/map_3d.png' alt="" draggable="false"/>
    {#each $map as zone}
        {#each zone['pins'] as pin}
            <Pin 
                position={pin.position_3D} 
                zone_focus = {zone.name == focus_on_zone}
                _zone={zone.name}
                _code={zone.name + pin.name}
            />
        {/each}
    {/each}
</div>

<style lang="scss">
    #pinned-map{
        transition: all 0.5s ease;
        position: relative;
        width: fit-content;
        height: fit-content;

        transform-origin: top left;

        img{
            z-index: -1;
            user-select: none;
        }
    }
</style>